// src/context/StreamContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import WebSocketManager from "../utils/WebSocketManager";
import { GlobalContext } from "../state";

const StreamContext = createContext(null);

export const StreamProvider = ({ children }) => {
  const globalState = useContext(GlobalContext);
  const [manager, setManager] = useState(null);

  useEffect(() => {
    let currentToken = localStorage.getItem('token');
    if (globalState.token) {
      currentToken = globalState.token;
    }
    if (currentToken) {
      setManager(new WebSocketManager(currentToken));
    } else {
      // Disconnect previous manager when token is cleared (logout)
      if (manager) {
        manager.disconnect();
      }
      setManager(null);
    }
  }, [globalState?.token, localStorage.getItem('token')]);

  return (
    <StreamContext.Provider value={manager}>
      {children}
    </StreamContext.Provider>
  );
};

export const useStream = () => useContext(StreamContext);
